<template>
  <div class="intallment-option-list" :class="{ mobile: isMobile() }">
    <InstallmentOptionBox
      class="installment-option-box"
      :class="{ mobile: isMobile() }"
      v-for="(intOpt, i) in installmentOptions"
      :loadingValues="loadingValues"
      :key="i"
      :installmentNumber="intOpt.installments"
      :installmentValue="intOpt.value"
      :interest="intOpt.interest"
      :totalValue="intOpt.total"
    />
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import InstallmentOptionBox from '@/components/common/InstallmentOptionBox.vue';

export default {
  name: 'installment-option-list',
  mixins: [StringMixin, UtilMixin],
  components: { InstallmentOptionBox },
  props: {
    installmentOptions: {
      type: Array,
      required: true,
    },
    loadingValues: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.intallment-option-list {
  display: flex;
  justify-content: space-around;
  &.mobile {
    flex-direction: column;
  }
}

.installment-option-box.mobile {
  padding-top: 8px;

  &:first-child  {
    padding-top: 0;
  }
}
</style>
